import React, {useCallback, useEffect, useState} from "react";
import {Input, Button, message, Space} from "antd";
import DraggableModal from "../../../components/DraggableModal";
import Api from '../../../api'
import {emptyValidate} from "../../../util/validate";

export default function CatalogueModal({onClose, onRemove, isShow, params}) {
    const [isOpen, setIsOpen] = useState(false)
    const [title, setTitle] = useState()
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (isShow) {
            setTitle(params.courseInfoName)
        }
        setIsOpen(isShow)
    }, [isShow])

    const save = useCallback(() => {
        let validateResult = emptyValidate(title, '请填写目录标题');
        if (validateResult) {
            return;
        }

        let data = {
            courseId:params.courseId,
            parentId:params.parentId,
            dicLevel:params.dicLevel,
            courseInfoName: title,
            typeCode: 0,
            courseInfoId: params.courseInfoId
        }
        setLoading(true)
        Api.createUpdateCourseInfo(data).then(resp=>{
            if (!data.courseInfoId){
                data.courseInfoId = resp.info
                data.sort = 0
            }
            onClose(data)
            setLoading(false)
        })
    })

    const deleteInfo = useCallback(()=>{
        Api.deleteCourseInfo(params.courseInfoId,params.courseId).then(resp=>{
            if (resp.resultCode ===1) {
                message.success(resp.resultMessage)
                onRemove && onRemove(params.courseInfoId)
                onClose()
            }
        })
    })

    return <DraggableModal
        title="创建目录"
        open={isOpen}
        onOk={save}
        onCancel={()=>onClose()}
        okText="保存"
        cancelText="取消"
        footer={null}
        maskClosable={false}
    >
        <Input className="mgt12" prefix={<span className="required">目录标题：</span>} value={title}  maxLength={80} onChange={(e)=>setTitle(e.target.value)} placeholder="请输入目录名称"/>
        <div className="flexbox justifyBetween mgt24">
            {params.courseInfoId ? <Button
                key="delete"
                danger
                onClick={deleteInfo}
            >
                删除
            </Button>:<span></span>}
            <Space>
            <Button key="cancel" onClick={()=>onClose()}>
                取消
            </Button>
            <Button key="submit" type="primary" loading={loading} onClick={save}>
                保存
            </Button>
            </Space>
        </div>
    </DraggableModal>
}